import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { combineLatest, of } from 'rxjs';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import {
  catchError,
  startWith,
  switchMap,
  filter,
  take,
} from 'rxjs/operators';
import { RuntimeConfigService } from '../services/runtime-config.service';

export const landingTokenGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const configService = inject(RuntimeConfigService);
  return combineLatest([
    auth.error$.pipe(startWith(null)),
    auth.isLoading$,
    auth.user$,
  ]).pipe(
    filter(
      ([ , isLoading]) => !isLoading
    ),
    take(1),
    switchMap(([error]) => {
      const landingAudience = configService.getConfig()?.auth0?.landingAudience;
      if (error) {
        return of(router.createUrlTree(['/error']));
      }
      return auth.getAccessTokenSilently({ cacheMode: 'cache-only' }).pipe(
        switchMap((token) => {
          interface ScopedToken extends JwtPayload {
            scope: string;
          }
          const decodedToken: ScopedToken | null = token
            ? jwtDecode<ScopedToken>(token)
            : null;
          if (decodedToken?.scope?.includes('update:user')) {
            return of(true);
          } else {
            auth.loginWithRedirect({
              appState: { target: state.url },
              authorizationParams: {
                scope: 'openid profile email update:user',
                audience: landingAudience,
              },
            });
            return of(false);
          }
        }),
        catchError(() => {
          auth.loginWithRedirect({
            appState: { target: state.url },
            authorizationParams: {
              scope: 'openid profile email update:user',
              audience: landingAudience,
            },
          });
          return of(false);
        }),
      );
      
    }),
  );
};
